import { ExportColumns, ExportSections } from "./geraeteManagementTypes";

export const exportColumnsMessstelle: Array<ExportColumns> = [
    {
        label: "Name",
        column: "name"
    },
    {
        label: "Breitengrad",
        column: "breitengrad"
    },
    {
        label: "Längengrad",
        column: "laengengrad"
    },
    {
        label: "Schaltfeld",
        column: "schaltfeld"
    },
    {
        label: "Spannungsebene",
        column: "spannungsebene"
    },
    {
        label: "Wandlerfaktor Strom",
        column: "stromwandler"
    },
    {
        label: "Wandlerfaktor Spannung",
        column: "spannungswandler"
    },
    {
        label: "Umspannwerk",
        column: "umspannwerk"
    },
    {
        label: "Kommentar",
        column: "kommentar"
    },
];
export const exportColumnsMessgeraet: Array<ExportColumns> = [
    {
        label: "Seriennummer",
        column: "messgeraetSeriennummer"
    },
    {
        label: "IP Adresse",
        column: "messgeraetIp"
    },
    {
        label: "Subnetzmaske",
        column: "messgeraetSubnetzmaske"
    },
    {
        label: "Herstellungsjahr",
        column: "messgeraetHerstellungsjahr"
    },
    {
        label: "Firmware",
        column: "messgeraetFirmware"
    },
    {
        label: "MAC Adresse",
        column: "messgeraetMacadresse"
    },
    {
        label: "Inbetriebnahmedatum",
        column: "messgeraetInbetriebnahmedatum"
    },
    {
        label: "Wartungsintervall",
        column: "messgeraetWartungsintervall"
    },
    {
        label: "Zeitsynchronisationsart",
        column: "messgeraetZeitsynchronisationsart"
    },
    {
        label: "Hersteller",
        column: "messgeraetHersteller"
    },
    {
        label: "Typ",
        column: "messgeraetTyp"
    },
    {
        label: "Kommentar",
        column: "messgeraetKommentar"
    },
];
export const exportColumnsRouter: Array<ExportColumns> = [
    {
        label: "Seriennummer",
        column: "routerSeriennummer"
    },
    {
        label: "IP Adresse",
        column: "routerIp"
    },
    {
        label: "Subnetzmaske",
        column: "routerSubnetzmaske"
    },
    {
        label: "Herstellungsjahr",
        column: "routerHerstellungsjahr"
    },
    {
        label: "Firmware",
        column: "routerFirmware"
    },
    {
        label: "MAC Adresse",
        column: "routerMacadresse"
    },
    {
        label: "Inbetriebnahmedatum",
        column: "routerInbetriebnahmedatum"
    },
    {
        label: "Wartungsintervall",
        column: "routerWartungsintervall"
    },
    {
        label: "Zeitsynchronisationsart",
        column: "routerZeitsynchronisationsart"
    },
    {
        label: "Hersteller",
        column: "routerHersteller"
    },
    {
        label: "Typ",
        column: "routerTyp"
    },
    {
        label: "Kommentar",
        column: "routerKommentar"
    },
];
export const exportSections: Array<ExportSections> = [
    {
        label: "Messstelle",
        category: "ms",
        exportColumns: exportColumnsMessstelle
    },
    {
        label: "Messgerät",
        category: "mg",
        exportColumns: exportColumnsMessgeraet
    },
    {
        label: "Router",
        category: "rou",
        exportColumns: exportColumnsRouter
    },

];
